import { t } from "@hakili/i18n";
import { HakiliMascot, type MascotState } from "@hakili/ui";

/**
 * `P1-DLW-052` and `P1-DLW-053` (designer R, batches 1 and 2; H: « cohérent »; D-1102-13: the agent is called Hakili): **Hakili's face**, the bank D2's « veilleur » reused as drawn (`HakiliMascot`, never redrawn), named for a screen reader.
 *
 * **Resting** (132 px, centred above the title) only in an EMPTY card: the empty day, the empty park, the empty dossier list; never over a failed read (a face must not carry a refusal or a failure), nor beside money or prices.
 * **In the pièces strip** (84 px) he is `flagging` (« Hakili, il signale ») or `done` (« Hakili, terminé »). `reading` (« il lit ») is not served and is not drawn. His stylesheet is `@hakili/ui/veilleur.css`, the bank's own
 * rules with the bank scope removed.
 */
export type HakiliState = Extract<MascotState, "idle" | "flagging" | "done">;
const LABEL: Readonly<Record<HakiliState, string>> = {
  idle: "dealer.hakili.repos",
  flagging: "dealer.hakili.signale",
  done: "dealer.hakili.termine",
};

export function HakiliFace(props: {
  readonly state?: HakiliState;
  readonly size?: "empty" | "strip";
}): React.JSX.Element {
  const state = props.state ?? "idle";
  const strip = props.size === "strip";
  return (
    <span
      className={strip ? "block w-[84px] shrink-0" : "mx-auto mb-2 block w-[132px]"}
      data-testid="hakili-face"
    >
      <HakiliMascot state={state} label={t(LABEL[state])} />
    </span>
  );
}
